import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const adminApi = axios.create({
    baseURL: `${BACKEND_URL}/api/admin`,
    withCredentials: true,
});

export const adminLogin = (password) => adminApi.post("/login", { password }).then((r) => r.data);
export const adminLogout = () => adminApi.post("/logout").then((r) => r.data);
export const adminMe = () => adminApi.get("/me").then((r) => r.data);
export const adminStats = () => adminApi.get("/stats").then((r) => r.data);
export const adminListAnalyses = (params = {}) =>
    adminApi.get("/analyses", { params }).then((r) => r.data);
export const adminAnalysisDetail = (id) =>
    adminApi.get(`/analyses/${id}`).then((r) => r.data);
export const adminListLeads = (params = {}) =>
    adminApi.get("/leads", { params }).then((r) => r.data);

// Failed / stuck paid reports — manual retry-from-admin recovery flow
export const adminFailedReports = () => adminApi.get("/failed-reports").then((r) => r.data);
export const adminRetryFailedReport = (id) =>
    adminApi.post(`/failed-reports/${id}/retry`).then((r) => r.data);

// Daily paid-report limit (Emergent Update Patch, Oct 2026)
export const adminGetDailyLimit = () => adminApi.get("/daily-limit").then((r) => r.data);
export const adminSetDailyLimit = (limit) =>
    adminApi.post("/daily-limit", { limit }).then((r) => r.data);

// Sample report (zero-AI-cost public demo)
export const adminSeedSampleReport = (analysisId, brideDisplayName, groomDisplayName) =>
    adminApi.post(`/sample-report/seed-from/${analysisId}`, null, {
        params: { bride_display_name: brideDisplayName, groom_display_name: groomDisplayName },
    }).then((r) => r.data);

// Wedding Intelligence Library
export const libList = (lib) => adminApi.get(`/library/${lib}`).then((r) => r.data);
export const libCreate = (lib, body) => adminApi.post(`/library/${lib}`, body).then((r) => r.data);
export const libUpdate = (lib, id, body) => adminApi.put(`/library/${lib}/${id}`, body).then((r) => r.data);
export const libDelete = (lib, id) => adminApi.delete(`/library/${lib}/${id}`).then((r) => r.data);

export async function libUpload(lib, file) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("library", lib);
    const { data } = await adminApi.post(`/library/upload`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data; // { url }
}
